import React from 'react';
import ReactExport from 'react-data-export';
import '../../views/ServiceReport.css';
import '../forms/Button.css';
import { getLocalizedDateTime } from '../../localization/LocalizedString';

const { ExcelFile } = ReactExport;
const { ExcelSheet, ExcelColumn } = ExcelFile;

const sortByDate = (items) => {
  return items.slice().sort((a, b) => {
    const aDate = new Date(a.date);
    const bDate = new Date(b.date);

    if (aDate > bDate) {
      return -1;
    }
    if (bDate > aDate) {
      return 1;
    }
    return 0;
  });
};

const ExportDatapickExcelButton = ({ currentLanguage, translate, data }) => {
  // sort by date
  const sortedTasks = sortByDate(data);

  return (
    <ExcelFile hideElement filename={translate('service_report.search.type_datapick')}>
      <ExcelSheet data={sortedTasks} name="Sheet1">
        <ExcelColumn label={translate('service_report.column_task.user')} value={(col) => col.userId} />
        <ExcelColumn label={translate('service_report.column_task.employeeId')} value={(col) => col.employeeId} />
        <ExcelColumn label={translate('service_report.column_task.date')} value={(col) => getLocalizedDateTime(new Date(col.date), currentLanguage)} />
        <ExcelColumn label={translate('service_report.column_task.customer')} value={(col) => col.customer.name} />
        <ExcelColumn label={translate('service_report.column_task.end_customer')} value={(col) => col.companyName} />
        <ExcelColumn label={translate('service_report.column_task.address')} value={(col) => col.streetAddress} />
        <ExcelColumn label={translate('service_report.column_task.city')} value={(col) => col.city} />
        <ExcelColumn label={translate('service_report.column_task.service_site')} value={(col) => col.siteId} />
        <ExcelColumn label={translate('service_report.column_task.productId')} value={(col) => col.productId} />
        <ExcelColumn label={translate('service_report.column_task.productAmount')} value={(col) => col.orderAmount} />
      </ExcelSheet>
    </ExcelFile>
  );
};

export default ExportDatapickExcelButton;



// WEBPACK FOOTER //
// ./src/components/servicereport/ExportDatapickExcelButton.js